import { PendingChangeKind, PendingChangesActionType } from 'constants/pendingChanges';
import { COLOR_PALETTE } from 'constants/ui';
import { getRecalculatedValueStyles } from 'styles/pendingChanges.styles';
import { getConditionalObject } from 'utils/data';

// The wrapper covers a value rendered outside textSelector; the text itself covers an inline-block value, which
// an ancestor's decoration does not reach.
const getRecalculatedStyles = textSelector => ({
  ...getRecalculatedValueStyles(),
  [`& ${textSelector}`]: getRecalculatedValueStyles(),
});

const getHighlightStyles = ({ textSelector, withBackground }) => ({
  ...getConditionalObject(withBackground, {
    // palette.background.highlight flips with the theme mode (light = the same ADDITIONAL[1]
    // cream tint this used to hardcode; dark = a low-alpha accent tint) — a hardcoded
    // ADDITIONAL[1] never flips and renders as a near-white blob on the dark canvas (STP-251).
    backgroundColor: ({ palette }) => palette.background.highlight,
  }),

  fontWeight: 700,

  [`& ${textSelector}`]: {
    color: `${COLOR_PALETTE.ADDITIONAL[2]} !important`,
    fontWeight: 700,
  },
});

export const getWrapperStyles = ({
  pendingChangesActionType,
  changeKind,
  sx,
  isSmall,
  textSelector,
  withBackground,
  isWithAuthors = false,
}) => ({
  overflow: 'hidden',
  maxWidth: '100%',
  height: 'fit-content',

  ...getConditionalObject(!!changeKind, () =>
    changeKind === PendingChangeKind.RECALCULATED
      ? getRecalculatedStyles(textSelector)
      : getHighlightStyles({ textSelector, withBackground }),
  ),

  ...getConditionalObject(pendingChangesActionType === PendingChangesActionType.DELETED, {
    pointerEvents: 'none',
    backgroundImage: `linear-gradient(to right, transparent 15px, ${COLOR_PALETTE.ADDITIONAL[2]} 15px, ${COLOR_PALETTE.ADDITIONAL[2]} calc(100% - 15px), transparent calc(100% - 15px))`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: '100% 1px',
  }),

  ...getConditionalObject(
    pendingChangesActionType === PendingChangesActionType.MODIFIED &&
      changeKind === PendingChangeKind.DIRECT,
    {
      width: 'fit-content',
      borderRadius: '4px',
      padding: isSmall ? '1px 4px' : '7px 8px',
    },
  ),

  // The author dots sit on the value's first line (a multi-line value such as an address keeps them
  // next to its first line); the value keeps its own truncation.
  ...getConditionalObject(isWithAuthors, {
    display: 'flex',
    alignItems: 'baseline',

    '& > :last-child': {
      minWidth: 0,
    },
  }),

  ...sx,
});
